export default {
    STANDARD: 'standard',
    ADDITIONAL: 'additional',
};